// Google Analytics (GA4). Loads only when REACT_APP_GA_ID is set at build time,
// so local dev builds without the env var ship no tracking code.
const GA_ID = process.env.REACT_APP_GA_ID;

if (GA_ID) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);
}
